import type { Invitation, IInvitationRepository } from '@knownow/domain'

export class GetInvitationByTokenUseCase {
  constructor(private readonly invitationRepo: IInvitationRepository) {}

  async execute(token: string): Promise<Invitation> {
    return this.invitationRepo.getByToken(token)
  }
}
